import "../index.css";
import { useState } from "react";
import Button from "../components/button/button";
import PolicyContainer from "../components/policy/policyContainer";
import axios from "axios";
import { baseURL } from "../baseURL";

const PopUpFormFeedback = ({ onClose, onSuccess, onError }) => {
  const [formState, setFormState] = useState({}); // Manage text and checkbox inputs
  const [files, setFiles] = useState([]); // Manage file inputs separately

  const handleChange = (e) => {
    const { name, value, type, checked, files: uploadedFiles } = e.target;

    if (type === "file") {
      setFiles(Array.from(uploadedFiles)); // Store uploaded files in state
    } else {
      setFormState((prevState) => ({
        ...prevState,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create a FormData object
    const formData = new FormData();

    // Append formState fields to FormData
    for (const key in formState) {
      formData.append(key, formState[key]);
    }

    // Append files to FormData
    files.forEach((file) => formData.append("files", file));

    try {
      const response = await axios.post(
        `${baseURL}/api/submit-feedback-form`,
        formData,
        {
          withCredentials: "true", // This matches the backend CORS policy
        }
      );

      if (response.status === 200) {
        onSuccess("feedback");
        onClose();
      }
    } catch (error) {
      console.error("Error submitting form:", error.response || error.message);
      onError(error);
    }
  };

  return (
    <div className="pop-up-form">
      <div className="form-header">
        <h4>Give us your Feedback</h4>
        <div className="close-btn-x" onClick={onClose}>
          <i class="fa-solid fa-xmark"></i>
        </div>
      </div>
      <form
        id="feedbackForm"
        onSubmit={handleSubmit}
        encType="multipart/form-data"
      >
        <p>
          Providing your contact information enables us to share best practices,
          communicate updates, and network with our global wildfire prevention
          community.
        </p>
        <input type="hidden" name="pageName" value="feedback" />
        <div className="form-group">
          <label htmlFor="firstName">*First Name</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">*Last Name</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">*Email</label>
          <input
            type="email"
            id="email"
            name="email"
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="organization">Organization</label>
          <input
            type="text"
            id="organization"
            name="organization"
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="role">Role</label>
          <input type="text" id="role" name="role" onChange={handleChange} />
        </div>
        <div className="form-group">
          <label htmlFor="zipCode">*Zip/Postal Code</label>
          <input
            type="text"
            id="zipCode"
            name="zipCode"
            onChange={handleChange}
            required
            minLength={4}
          />
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            id="subscribe"
            name="subscribe"
            onChange={handleChange}
          />
          <label htmlFor="subscribe">
            Subscribe to Updates, Events and News
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            cols="50"
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="form-group">
          <label htmlFor="files">
            <span className="text-gold">Upload Files</span> (Images, PDFs,
            XLS(x), Max 20MB each)
          </label>
          <input
            type="file"
            id="files"
            name="files"
            onChange={handleChange}
            multiple
            accept=".jpg,.jpeg,.png,.svg,.pdf,.doc,.docx,.xlsx,.xls,.ppt"
          />
        </div>
        <div className="form-group">
          <label htmlFor="links">Links:</label>
          <textarea
            id="links"
            name="links"
            onChange={handleChange}
            cols="50"
            placeholder="If the file is too large or the extension is not accepted, please enter links to your files here."
          ></textarea>
        </div>
        <Button
          text="Submit Feedback"
          color="var(--green)"
          className="pop-up-btn"
        />
      </form>
      <div className="policy">
        <PolicyContainer text="Subit Feedback" />
      </div>
      <div className="form-footer">
        <div className="form-close-btn" onClick={onClose}>
          Close
        </div>
      </div>
    </div>
  );
};

export default PopUpFormFeedback;
